import { ReactElement } from 'react';

import { Disclosure } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faShoppingCart,
} from '@fortawesome/free-solid-svg-icons';
import { Link } from '@appsumo/dorado-react';

import { CartProps } from '~/types/cart';
import CartItemList from './CartItemList';

export function ViewCart({
  cart,
}: Readonly<{ cart?: CartProps }>): ReactElement {
  if (!cart?.cart_items?.length) return <></>;

  return (
    <div className="w-full rounded border-[1px] border-sundog p-4">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="flex w-full font-medium">
              <FontAwesomeIcon icon={faShoppingCart} className="my-auto mr-2" />
              View cart{' '}
              {`(${cart.cart_items.length} Item${
                cart.cart_items.length > 1 ? 's' : ''
              })`}
              {open && (
                <FontAwesomeIcon
                  icon={faChevronUp}
                  className="my-auto ml-auto text-bolt"
                />
              )}
              {!open && (
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className="my-auto ml-auto text-bolt"
                />
              )}
            </Disclosure.Button>
            <Disclosure.Panel>
              <CartItemList cartItems={cart?.cart_items || []} />
              <div className="w-full text-right">
                <Link href="/cart" styled>
                  Edit cart
                </Link>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
